var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntgPackSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.992,
    height: 12.992,
    viewBox: "0 0 12.992 12.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.742 16.742) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,4.5v7.661",
    transform: "translate(-2.585 0)",
    fill: "none",
    stroke: "#009021",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.331,6.415A1.915,1.915,0,1,1,24.415,4.5a1.915,1.915,0,0,1,1.915,1.915Z",
    transform: "translate(-10.339 0)",
    fill: "none",
    stroke: "#009021",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.331,24.415A1.915,1.915,0,1,1,6.415,22.5,1.915,1.915,0,0,1,8.331,24.415Z",
    transform: "translate(0 -10.339)",
    fill: "none",
    stroke: "#009021",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.246,13.5A5.746,5.746,0,0,1,13.5,19.246",
    transform: "translate(-5.169 -5.169)",
    fill: "none",
    stroke: "#009021",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntgPackSmall);
export default __webpack_public_path__ + "static/media/intg_pack_small.2a9a508bd2a4ad9f4e97647c7434b41b.svg";
export { ForwardRef as ReactComponent };